const copyName = (tickerName: string, tickerList: string[]) => {
    let count = 0;
    if (!tickerName?.includes('copy')) {
        tickerList.forEach(name => {
            if ((name?.includes(`${tickerName}-copy`)) && (name.length <= `${tickerName}-copy ___`.length)) {
                let mass = name.split(" ")[0]
                if (count < Number(mass[mass.length - 1])) {
                    count = Number(mass[mass.length - 1])
                }
            }
        })
    }
    else {
        tickerList.forEach(name => {
            if ((name.includes(`${tickerName}-copy`))) {
                let splitName = name.split(`${tickerName}-copy`)
                let mass = splitName[1].split(" ")[0]
                if (count < Number(mass[0])) {
                    count = Number(mass[0])
                }
            }
        })
    }
    return `${tickerName}-copy${count + 1}`
}
export default copyName
